module.exports = __webpack_public_path__ + "img/employee-list.f9624d57.svg";